module.exports = __webpack_public_path__ + "img/7.4b27a86d.jpg";